import { render, staticRenderFns } from "./Nrenvipbody.vue?vue&type=template&id=8ced292a&scoped=true&"
import script from "./Nrenvipbody.vue?vue&type=script&lang=js&"
export * from "./Nrenvipbody.vue?vue&type=script&lang=js&"
import style0 from "./Nrenvipbody.vue?vue&type=style&index=0&id=8ced292a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ced292a",
  null
  
)

export default component.exports